import loadable from '@loadable/component';

export const LazyPurchaseConfirmationDialog = loadable(() => import(/* webpackChunkName: "content/guest/registry/purchaseconfirmationdialog" */ './PurchaseConfirmationDialog'));
